// extracted by mini-css-extract-plugin
module.exports = {"swiper":"trending_swiper__JCYAf"};